jQuery.feature_import(
  'js-mashie-translate-mode',
  () => require('./mashie-translate-mode.js'),
  mod => mod.feature_js_mashie_translate_mode
);
